export type CategoryKey =
  | 'all'
  | 'ent'
  | 'film'
  | 'social'
  | 'tech'
  | 'sports'
  | 'finance'
  | 'game';

export interface Category {
  key: CategoryKey;
  label: string;
  icon: string;
}

export const categories: Category[] = [
  { key: 'all', label: '全部瓜料', icon: 'ri-fire-line' },
  { key: 'ent', label: '娱乐圈', icon: 'ri-star-smile-line' },
  { key: 'film', label: '影视综艺', icon: 'ri-film-line' },
  { key: 'social', label: '社会热点', icon: 'ri-earth-line' },
  { key: 'tech', label: '科技数码', icon: 'ri-cpu-line' },
  { key: 'sports', label: '体坛动态', icon: 'ri-trophy-line' },
  { key: 'finance', label: '财经楼市', icon: 'ri-line-chart-line' },
  { key: 'game', label: '游戏电竞', icon: 'ri-gamepad-line' },
];

export interface HotEvent {
  id: number;
  catKey: Exclude<CategoryKey, 'all'>;
  title: string;
  summary: string;
  heat: number;
  comments: number;
  time: string;
  tags: string[];
  mark?: '爆' | '热' | '新' | null;
}

export const hotEvents: HotEvent[] = [
  {
    id: 1,
    catKey: 'ent',
    title: '内娱新晋女团首专同名主打歌 MV 上线即登顶热搜',
    summary: '出道首张专辑同名主打歌 MV 上线仅 3 小时播放量破千万，编舞与歌词片段被全网二创，讨论热度持续飙升。',
    heat: 986,
    comments: 4280,
    time: '12 分钟前',
    tags: ['女团', '打歌', '二创'],
    mark: '爆',
  },
  {
    id: 2,
    catKey: 'social',
    title: '多地推行“居民议事亭”模式，社区大小事一起商量着办',
    summary: '记者走访发现，不少小区把架空层改造成议事亭，物业费、加装电梯、宠物公约等难题都有了面对面讨论的新解法。',
    heat: 932,
    comments: 2960,
    time: '38 分钟前',
    tags: ['社区', '民生', '治理'],
    mark: '热',
  },
  {
    id: 3,
    catKey: 'tech',
    title: '国产品牌发布新一代折叠旗舰：更轻薄，续航提升明显',
    summary: '新机采用升级铰链与电池技术，机身更薄的同时续航显著提升，首发配色与影像参数引发科技圈集体围观。',
    heat: 870,
    comments: 1830,
    time: '1 小时前',
    tags: ['折叠屏', '旗舰机', '数码'],
    mark: '热',
  },
  {
    id: 4,
    catKey: 'film',
    title: '古装大剧杀青特辑曝光，美术置景细节获好评',
    summary: '历经 4 个月拍摄的年度古装剧释出杀青特辑，现场服化道与实景搭建的用心程度引发网友讨论，预约人数持续上涨。',
    heat: 801,
    comments: 1420,
    time: '2 小时前',
    tags: ['古装剧', '杀青', '置景'],
  },
  {
    id: 5,
    catKey: 'sports',
    title: '亚洲杯预选赛今晚开战，主力名单正式公布',
    summary: '国足公布最新一期大名单，多位年轻球员入选引发讨论，主帅在赛前发布会上强调“敢打敢拼、不留遗憾”。',
    heat: 778,
    comments: 2210,
    time: '3 小时前',
    tags: ['国足', '预选赛', '名单'],
    mark: '热',
  },
  {
    id: 6,
    catKey: 'finance',
    title: '多城发布优化政策，支持刚性与改善性住房需求',
    summary: '近期多城调整公积金与购房政策，专家解读认为将释放合理购房需求，市场信心有望逐步修复。',
    heat: 690,
    comments: 1680,
    time: '4 小时前',
    tags: ['楼市', '公积金', '政策'],
  },
  {
    id: 7,
    catKey: 'game',
    title: '电竞赛事总决赛门票三秒售罄，二手价被炒高数倍',
    summary: '年度职业联赛总决赛门票开售后迅速售罄，主办方提示认准官方渠道，谨防高价倒票与诈骗。',
    heat: 655,
    comments: 1190,
    time: '5 小时前',
    tags: ['电竞', '门票', '职业联赛'],
  },
  {
    id: 8,
    catKey: 'ent',
    title: '音乐人机场接机秩序引争议，粉丝接机公约再被热议',
    summary: '某歌手抵达航班引来大量粉丝聚集，航站楼秩序引发讨论，不少人呼吁“理性追星、文明接机”。',
    heat: 602,
    comments: 3420,
    time: '6 小时前',
    tags: ['追星', '接机', '公约'],
  },
  {
    id: 9,
    catKey: 'social',
    title: '入秋首场强冷空气来袭，多地发布大风降温提示',
    summary: '中央气象台发布预报，新一轮冷空气将自西向东影响我国，提醒大家及时添衣、注意出行安全。',
    heat: 588,
    comments: 860,
    time: '7 小时前',
    tags: ['天气', '降温', '提示'],
  },
  {
    id: 10,
    catKey: 'tech',
    title: '大模型应用落地提速：手机厂商竞相接入端侧 AI 助手',
    summary: '随着端侧算力提升，多家厂商发布搭载本地大模型的手机助手，离线可用、隐私更安全成为新卖点。',
    heat: 520,
    comments: 940,
    time: '8 小时前',
    tags: ['AI', '大模型', '端侧'],
  },
  {
    id: 11,
    catKey: 'film',
    title: '国庆档片单陆续官宣，多部影片定档引期待',
    summary: '随着假期临近，多部影片陆续宣布定档，涵盖喜剧、动画与悬疑题材，影院排片与票价成为影迷热议话题。',
    heat: 480,
    comments: 1300,
    time: '9 小时前',
    tags: ['国庆档', '定档', '观影'],
  },
  {
    id: 12,
    catKey: 'sports',
    title: '城市马拉松周末开跑，3.5 万人共赴赛道之约',
    summary: '本周末多场城市马拉松同步开跑，跑者装备、补给与沿途观赛氛围成为社交平台上的热门分享内容。',
    heat: 450,
    comments: 720,
    time: '10 小时前',
    tags: ['马拉松', '跑步', '城市'],
  },
  {
    id: 13,
    catKey: 'finance',
    title: '“网红小吃”排队经济再引热议，是营销还是真香',
    summary: '多家新晋网红餐饮店动辄排队数小时，有消费者表示“味道确实能打”，也有声音质疑过度营销，讨论两极分化。',
    heat: 428,
    comments: 2050,
    time: '11 小时前',
    tags: ['餐饮', '网红店', '消费'],
  },
  {
    id: 14,
    catKey: 'game',
    title: '国产单机新作全球销量突破百万份，Steam 好评如潮',
    summary: '一款国产动作冒险游戏发售后口碑发酵，两周内全球销量破百万，被不少玩家称为“年度惊喜”。',
    heat: 396,
    comments: 1580,
    time: '12 小时前',
    tags: ['单机', 'Steam', '国产游戏'],
  },
  {
    id: 15,
    catKey: 'ent',
    title: '综艺真人秀官宣新阵容，户外季“全员喜剧人”',
    summary: '热门户外真人秀新一季阵容官宣，嘉宾互动与先导预告搞笑片段刷屏，网友直呼“这季稳了”。',
    heat: 358,
    comments: 1120,
    time: '14 小时前',
    tags: ['综艺', '真人秀', '阵容'],
  },
  {
    id: 16,
    catKey: 'social',
    title: '博物馆“夜游专场”爆火，年轻人在馆里过周末',
    summary: '多家博物馆开设夜场与主题沉浸展，吸引大量年轻观众打卡，文创与盖章玩法让逛展有了新乐趣。',
    heat: 336,
    comments: 640,
    time: '16 小时前',
    tags: ['博物馆', '夜游', '文创'],
  },
  {
    id: 17,
    catKey: 'tech',
    title: '太空站又迎货运任务，实验舱载荷再上新',
    summary: '货运飞船成功对接空间站，一批新科学实验载荷顺利抵达，航天话题再度冲上话题榜。',
    heat: 305,
    comments: 780,
    time: '18 小时前',
    tags: ['航天', '空间站', '科学'],
  },
  {
    id: 18,
    catKey: 'sports',
    title: 'CBA 新赛季揭幕，揭幕战加时决胜全场沸腾',
    summary: '新赛季常规赛揭幕战上演加时好戏，两队外援与本土新星均有亮眼发挥，现场氛围拉满。',
    heat: 288,
    comments: 590,
    time: '昨天',
    tags: ['CBA', '揭幕战', '篮球'],
  },
];

export interface HotTopic {
  rank: number;
  title: string;
  heat: number;
}

export const hotTopics: HotTopic[] = [
  { rank: 1, title: '新女团首专主打歌 MV 上线', heat: 986 },
  { rank: 2, title: '居民议事亭多地落地', heat: 932 },
  { rank: 3, title: '新一代折叠旗舰发布', heat: 870 },
  { rank: 4, title: '古装大剧杀青特辑曝光', heat: 801 },
  { rank: 5, title: '亚洲杯预选赛今晚开战', heat: 778 },
  { rank: 6, title: '多城优化住房支持政策', heat: 690 },
  { rank: 7, title: '电竞赛事总决赛门票售罄', heat: 655 },
  { rank: 8, title: '追星接机公约再热议', heat: 602 },
  { rank: 9, title: '入秋强冷空气来袭', heat: 588 },
  { rank: 10, title: '端侧 AI 助手加速落地', heat: 520 },
];

export interface TimelineItem {
  time: string;
  category: string;
  content: string;
}

export const todayTimeline: TimelineItem[] = [
  { time: '09:12', category: '娱乐圈', content: '新女团主打歌 MV 上线即登顶各大平台热搜。' },
  { time: '09:40', category: '社会', content: '多地“居民议事亭”模式获广泛点赞。' },
  { time: '10:05', category: '科技', content: '新一代折叠旗舰正式发布，预约通道开启。' },
  { time: '10:38', category: '影视', content: '古装大剧释出杀青特辑，置景细节被盛赞。' },
  { time: '11:20', category: '体育', content: '国家队公布新一期名单，多位小将入选。' },
  { time: '12:00', category: '财经', content: '多城发布公积金与购房优化政策解读。' },
  { time: '14:30', category: '游戏', content: '电竞赛事总决赛门票开售三秒售罄。' },
  { time: '16:00', category: '社会', content: '气象部门发布入秋首场强冷空气预警。' },
];

export interface FeaturedArticle {
  id: number;
  tag: string;
  title: string;
  excerpt: string;
  date: string;
  readMin: number;
  image: string;
}

export const featuredArticles: FeaturedArticle[] = [
  {
    id: 1,
    tag: '深度观察',
    title: '追星接机这一年：我们到底在“接”什么？',
    excerpt: '从疯狂到理性，从聚光灯到日常化，围绕粉丝接机的争议背后，是一代年轻人追星方式的悄然转变。',
    date: '2026-09-06',
    readMin: 8,
    image: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20fans%20holding%20lightsticks%20at%20an%20airport%20terminal%2C%20watermelon%20red%20and%20green%20palette%2C%20flat%20modern%20vector%2C%20soft%20cream%20background%2C%20energetic%20and%20heartwarming&width=800&height=480&seq=gua-fea-1&orientation=landscape',
  },
  {
    id: 2,
    tag: '科技观察',
    title: '端侧大模型这一年：离线 AI 离我们还有多远？',
    excerpt: '当大模型从云端走向手机，隐私、速度与体验的新平衡正在被重新定义，普通人是否真的用上了更聪明的助手？',
    date: '2026-09-05',
    readMin: 10,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20a%20smartphone%20with%20glowing%20neural%20network%20circuit%20lines%2C%20watermelon%20green%20and%20red%20accents%2C%20flat%20editorial%20vector%20style%2C%20clean%20cream%20background&width=800&height=480&seq=gua-fea-2&orientation=landscape',
  },
  {
    id: 3,
    tag: '消费观察',
    title: '排队两小时的网红店，凭什么让人“真香”？',
    excerpt: '一边是吐槽“过度营销”，一边是门口的长队，网红餐饮的排队经济学，或许比我们想象的更复杂也更真实。',
    date: '2026-09-04',
    readMin: 7,
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20colorful%20food%20stall%20with%20a%20queue%20of%20people%20waiting%2C%20warm%20watermelon%20red%20green%20yellow%20palette%2C%20playful%20modern%20editorial%20vector%20art%2C%20soft%20background&width=800&height=480&seq=gua-fea-3&orientation=landscape',
  },
  {
    id: 4,
    tag: '生活观察',
    title: '博物馆之夜：年轻人为什么开始“逛馆过周末”？',
    excerpt: '夜游、沉浸展、盖章、文创……博物馆正以更年轻的姿态走进生活，也悄悄改变着周末的打开方式。',
    date: '2026-09-03',
    readMin: 6,
    image: 'https://readdy.ai/api/search-image?query=Illustration%20of%20young%20people%20exploring%20a%20museum%20gallery%20at%20night%20with%20warm%20spotlights%2C%20watermelon%20green%20and%20cream%20tones%2C%20flat%20modern%20vector%20art%2C%20soft%20atmospheric%20lighting&width=800&height=480&seq=gua-fea-4&orientation=landscape',
  },
];

export interface Principle {
  icon: string;
  title: string;
  desc: string;
}

export const principles: Principle[] = [
  {
    icon: 'ri-eye-line',
    title: '理性吃瓜',
    desc: '看热闹可以，但也请对未经证实的信息多一份谨慎，让子弹多飞一会儿。',
  },
  {
    icon: 'ri-time-line',
    title: '追更不追谣',
    desc: '以官方与当事人确认为准，不信谣不传谣，让每一次“吃瓜”都有依据。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '文明表达',
    desc: '讨论事件本身，不进行人身攻击，理性声音才是真正的“高赞”。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '保护隐私',
    desc: '不传播他人未经公开的个人信息，吃瓜有边界，尊重是底线。',
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '吃瓜大全的内容多久更新一次？',
    a: '我们每日分早、午、晚多个时段更新。早间汇总昨日夜里的热点，午间盘点当日进行中的事件，晚间输出“今日瓜料打包”，帮助你在碎片时间里掌握当天大事。',
  },
  {
    q: '热门事件会按哪些栏目分类？',
    a: '目前设有娱乐圈、影视综艺、社会热点、科技数码、体坛动态、财经楼市、游戏电竞等主要栏目，每条热点都会打上分类标签，便于你按兴趣筛选浏览。',
  },
  {
    q: '如何判断一条瓜料是否靠谱？',
    a: '我们会优先采用官方渠道、权威媒体与多方信源交叉确认的信息。对于仍在发酵中的事件，会明确标注“待核实”并持续跟进更新，建议你以权威通报为准。',
  },
  {
    q: '看到有兴趣的热点，怎么分享给朋友？',
    a: '每条事件都支持一键复制链接与分享，你可以把感兴趣的瓜料转发到微信、微博等社交平台，和好友一起追更、一起讨论。',
  },
  {
    q: '可以投稿或提供线索吗？',
    a: '当然可以。如果你有值得讨论的事件线索或希望我们深挖的话题，欢迎通过页面底部的联系方式告诉我们，我们会认真评估每一条线索。',
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  initial: string;
}

export const testimonials: Testimonial[] = [
  {
    name: '橘子汽水',
    role: '追剧吃瓜党 · 在校学生',
    text: '每天中午吃饭前先刷一遍今日汇总，大事小情基本都能掌握，中午和同学聊天再也不怕跟不上话题了。',
    initial: '橘',
  },
  {
    name: '阿野',
    role: '科技数码爱好者',
    text: '分类很清楚，科技栏目的瓜料质量挺高，深度专题写得也实在，不是标题党，会一直追更。',
    initial: '阿',
  },
  {
    name: '木子青',
    role: '上班族 · 通勤路上',
    text: '把热搜榜和栏目放在一起真的很方便，通勤路上十几分钟就能把热点刷个明白，省心又高效。',
    initial: '木',
  },
  {
    name: '南风',
    role: '资深冲浪选手',
    text: '难得见到把“吃瓜”做得这么有条理的地方，理性吃瓜的氛围也让我愿意留在这里慢慢看。',
    initial: '南',
  },
];